// src/locales/en.chat.ts

const chat = {  

      //Chat
  chat: {
    // --- deletes / confirmations ---
    deleteMessage: {
      everyone: "Delete this message for everyone?",
      me: "Delete this message for you?",
    },

    deletedUser: "Deleted User",

    deleteConversation: {
      deletedUser:
        "Permanently delete this conversation? All messages and media will be removed and cannot be recovered.",
      // {{name}} is optional – you already pass empty string if unknown
      normal:
        "Delete this conversation with {{name}}? The other participant will still keep their copy (messages, media and profile name).",
    },

    // --- E2EE / errors ---
    e2eeInitializing: "Secure chat is still initializing on this device.",
    // {{msg}} = API error message from backend
    sendFailed: "Failed to send: {{msg}}",

    // --- sidebar / preview labels ---
    preview: {
      message: "Message",
      photo: "Photo",
      video: "Video",
      audio: "Audio",
      media: "Media",
    },

    // --- header / profile bits ---
    openVisitorProfile: "Open visitor profile",
    fallbackUser: "User",
    unknownUser: "Unknown User",

    // --- composer / buttons / hints ---
    addMedia: "Add media",
    pickChatFirst: "Pick a chat first",
    replying: "Replying to",
    placeholder: "Type a message…",
    emoji: "Emoji",
    send: "Send",    

    // --- empty / helper text ---
    selectUserHint: "Select a user on the left to start chatting.",

    upload: {
      headerTitle: "Send media to {{name}}",
      genericUser: "User",

      back: "Back",

      addButton: "Add photos/videos",
      addButtonTitleReady: "Pick photos & videos",
      addButtonTitleInit: "Secure chat is initializing…",

      dropTitle: "Click or drop files here",
      dropHelp: "Click to pick images/videos or drop them here",

      ttlTitle: "How long this media should remain available after it’s viewed",
      ttl: {
        choose: "Choose expiry…",
        afterView: "Immediately after view",
        min1: "1 minute",
        min5: "5 minutes",
        hour1: "1 hour",
        hours24: "24 hours",
        days3: "3 days",
        days30: "30 days",
      },

      sendCta: "Send {{count}} & go →",

      kindImage: "Image",
      kindVideo: "Video",

      remove: "Remove",
    },
    message: {
      media: {
        expired: "Expired",
        expiredTitle: "Media expired",
        show: "Show media",
        showWithCount: "Show media ({{count}})",
      },
      menu: {
        optionsTitle: "Message options",
        copy: "Copy",
        reply: "Reply",
        delete: "Delete message",
      },
      quoted: {
        unknownUser: "User",
      },

      
    },
    date: { 
      today: "Today",
      yesterday: "Yesterday",

   },
  },
  
  //ChatMediaPresentation
  chatMedia: {
    videoTitle: 'Video',
    noMedia: 'No media to show.',
  },


} as const;      
  
export default chat;
